import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Toast, ToastService } from '../../../core/services/toast.service';

@Component({
    selector: 'app-toast-container',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="toast-container" role="region" aria-label="Notifications" aria-live="polite">
      <div *ngFor="let t of toasts; trackBy: trackById"
           class="toast"
           [class.toast-success]="t.type === 'success'"
           [class.toast-error]="t.type === 'error'"
           [class.toast-warning]="t.type === 'warning'"
           [class.toast-info]="t.type === 'info'"
           role="alert">
        <div class="toast-icon">
          <ng-container [ngSwitch]="t.type">
            <span *ngSwitchCase="'success'">✓</span>
            <span *ngSwitchCase="'error'">✕</span>
            <span *ngSwitchCase="'warning'">!</span>
            <span *ngSwitchDefault>i</span>
          </ng-container>
        </div>
        <div class="toast-body">
          <div class="toast-msg">{{ t.message }}</div>
          <button *ngIf="t.action" class="toast-action" (click)="runAction(t)">
            {{ t.action.label }}
          </button>
        </div>
        <button class="toast-close" (click)="dismiss(t.id)" aria-label="Dismiss">×</button>
      </div>
    </div>
  `,
    styleUrls: ['./toast-container.component.scss']
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private sub?: Subscription;

  constructor(private toastService: ToastService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.sub = this.toastService.toasts$.subscribe(list => {
      this.toasts = list;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  runAction(t: Toast): void {
    try { t.action?.callback(); } catch { /* noop */ }
    this.toastService.dismiss(t.id);
  }

  trackById = (_: number, t: Toast) => t.id;
}
